import { App } from 'vue';
import {
  Popover,
  Select,
  Checkbox,
  Cascader,
  Button,
  Rate,
  Menu,
  Empty,
  Dropdown,
  Breadcrumb,
  Tabs,
  Card,
  Row,
  Col,
  List,
  Spin,
  Carousel,
  Table,
  Avatar,
  Tooltip,
  Modal,
  Upload, // ✅ 补上
  Input,   // ✅ a-input 和 a-input-search 都来源于 Input
} from 'ant-design-vue';

const AntdComponents = [
  Popover,
  Select,
  Checkbox,
  Cascader,
  Button,
  Rate,
  Menu,
  Empty,
  Dropdown,
  Breadcrumb,
  Tabs,
  Card,
  Row,
  Col,
  List,
  Spin,
  Carousel,
  Table,
  Avatar,
  Tooltip,
  Modal,
  Upload,     // ✅ 确保 Upload 组件已注册
  Input       // ✅ 确保 InputSearch 生效
];

// 子组件注册
const SubComponents = {
  AMenuItem: Menu.Item,
  ASubMenu: Menu.SubMenu,
  AMenuItemGroup: Menu.ItemGroup,
  ATabPane: Tabs.TabPane,
  AInputSearch: Input.Search,
};

/**
 * 注册所有 Ant Design Vue 的组件
 */
export default {
  install(app: App) {
    AntdComponents.forEach((component) => {
      app.component(component.name, component);
    });
    Object.entries(SubComponents).forEach(([name, component]) => {
      app.component(name, component);
    });
  },
};
